import { SUPPLIER_QUESTIONNAIRE_CATEGORIES } from "../../../../../../../SupplierQuestionnaire/helpers";
import { Badge } from "@chakra-ui/react";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { QUESTIONNAIRE_STATUSES } from "../../../../../../../../utils";

function StatusBadge({ cellObj, year, onClickHandler }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage.suppliersData.supplierEngagement.supplierEngagementGrid"
  });

  const getBackgroundColor = (questionnaireType) => {
    switch (questionnaireType) {
      case SUPPLIER_QUESTIONNAIRE_CATEGORIES.PRODUCT:
        return "hsl(21,77%,46%)";
      case SUPPLIER_QUESTIONNAIRE_CATEGORIES.LOCATION:
        return "hsl(199, 72%, 30%)";
      case SUPPLIER_QUESTIONNAIRE_CATEGORIES.REVENUE:
        return "hsl(128, 62%, 26%)";
      default:
        return "white";
    }
  };

  const isReviewable = cellObj[`ghgQuestionnaireId${year}`] &&
    (cellObj[`ghgOriginalStatus${year}`] &&
      [QUESTIONNAIRE_STATUSES.IN_PROGRESS, QUESTIONNAIRE_STATUSES.FINALIZED].includes(cellObj[`ghgOriginalStatus${year}`])
    );

  return (
    <Badge
      backgroundColor={getBackgroundColor(cellObj[`ghgType${year}`])}
      color={getBackgroundColor(cellObj[`ghgType${year}`]) !== "white" ? "white" : "black"}
      height="max-content"
      textTransform={"unset"}
      fontSize={"md"}
      fontWeight={"400"}
      title={isReviewable ?
        t("labels.reviewGHGQuestionnaire", { type: t(`questionnaireTypes.${cellObj[`ghgType${year}`]}`) }) : ""}
      textDecoration={isReviewable ? "underline" : "none"}
      cursor={isReviewable ? "pointer" : "auto"}
      onClick={isReviewable ? () => onClickHandler(cellObj[`ghgQuestionnaireId${year}`]) : null}
    >
      {cellObj[`ghgStatus${year}`]}
    </Badge>
  );
}

export default StatusBadge;